import React from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import SafeIcon from '../common/SafeIcon';
import { FiPhone } from 'react-icons/fi';

export default function Internal() {
  return (
    <section>
      <SectionHeader id="contact" title="Support & Further Info" subtitle="Direct line for complex queries and custom deals." />
      
      <div className="bg-emerald-900/20 border border-emerald-500/30 p-8 rounded-2xl flex flex-col items-center text-center">
        <div className="bg-emerald-500/10 w-16 h-16 rounded-full flex items-center justify-center mb-6">
          <SafeIcon icon={FiPhone} className="text-emerald-500 text-2xl" />
        </div>
        <h3 className="text-2xl font-bold text-white mb-2">Need more information?</h3>
        <p className="text-slate-300 mb-6 max-w-md">
          For custom commercial setups, technical deep dives, or urgent questions, please contact the founder directly.
        </p>
        <a 
          href="https://wa.me/4527577601" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 px-8 rounded-full transition-all flex items-center space-x-2 shadow-lg shadow-emerald-900/20"
        >
          <span>Contact Kasper on WhatsApp</span>
          <span className="text-emerald-200 ml-2 font-mono">+45 27 57 76 01</span>
        </a>
      </div>
    </section>
  );
}